var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transaction-container"},[_c('Header'),_c('AccountDetail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }